export const convertObjectToBlob = (object) => {
  const json = JSON.stringify(object);
  return new Blob([json], { type: 'application/json' });
};
